import { Component, OnInit } from '@angular/core';
import { AppData } from 'src/app/features/arc/services/appdata.service';

@Component({
  selector: 'app-arc-japan',
  templateUrl: './arc-japan.component.html',
  styleUrls: ['./arc-japan.component.css']
})
export class ArcJapanComponent implements OnInit {

  constructor(
    private appData: AppData
  ) {
    this.appData.set('app_type', 'arc_japan_invoice');
  }

  ngOnInit(): void {
  }
}
